var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:(_vm.cssProps)},[_c('div',{staticClass:"sk-cube-grid"},[_vm._l((_vm.numberOfCells),function(n){return [_c('div',{class:'sk-cube sk-cube' + _vm.circularRange.next().value})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }